import { defineAsyncComponent } from "vue";

const RenderTemplate = defineAsyncComponent(() => import("./render-template.vue"));

export { RenderTemplate };
